import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=bc1a3536&scoped=true"
import script from "./Remote.vue?vue&type=script&lang=ts"
export * from "./Remote.vue?vue&type=script&lang=ts"
import style0 from "./Remote.vue?vue&type=style&index=0&id=bc1a3536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a3536",
  null
  
)

export default component.exports